import styled from "styled-components";

const P = styled.p`
  letter-spacing: 0.01em;
  color: #4b3731;
  padding: 0 0 20px 0;
`;

export default P;
